export var BonusHistoryOriginEnum;
(function (BonusHistoryOriginEnum) {
    BonusHistoryOriginEnum["USER_VERIFICATION"] = "USER_VERIFICATION";
    BonusHistoryOriginEnum["EXCHANGE"] = "EXCHANGE";
    BonusHistoryOriginEnum["CLAIM"] = "CLAIM";
})(BonusHistoryOriginEnum || (BonusHistoryOriginEnum = {}));
//# sourceMappingURL=bonus-history-origin.enum.js.map